import { isUndef } from '@lhb/func';

function normalizeText(value: any) {
  return typeof value === 'string' ? value.trim() : '';
}

function parseHeightLimitValue(value: string) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

export function getHeightLimitValue(value: any): string | undefined {
  if (isUndef(value) || value === null) {
    return undefined;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? `${value}` : undefined;
  }

  if (typeof value === 'string') {
    const text = normalizeText(value);
    if (!text) {
      return undefined;
    }

    const parsedValue = parseHeightLimitValue(text);
    if (parsedValue === text) {
      return text;
    }
    return getHeightLimitValue(parsedValue);
  }

  if (typeof value === 'object') {
    return getHeightLimitValue(value.value);
  }

  return undefined;
}
